'use client';

import { createContext, useContext, useMemo } from 'react';

export type User = {
  id: string;
  name: string;
  color: string;
  avatar?: string;
};

export type UserContextValue = {
  user: User;
};

const UserContext = createContext<UserContextValue | null>(null);

export function UserProvider({ children, user }: { children: React.ReactNode; user?: User }) {
  const value = useMemo<UserContextValue | null>(() => (user ? { user } : null), [user]);
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export function useUser(): UserContextValue {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
}

export function useOptionalUser(): User | null {
  return useContext(UserContext)?.user ?? null;
}
